import Logo from 'components/Logo';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import SmallLogo from './assets/SmallLogo';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';

const Header = () => {
  const { oktaAuth } = useOktaAuth();

  const onLogin = () => {
    const originalUri = toRelativeUrl(
      window.location.href,
      window.location.origin,
    );
    oktaAuth.setOriginalUri(originalUri);
    oktaAuth.signInWithRedirect();
  };

  return (
    <header className="flex min-h-[104px] flex-wrap items-center justify-between gap-2 border-b border-[rgba(19,_30,_41,_0.35)] bg-background-base-surface-2 px-4 py-2 md:px-24">
      <div className="flex items-center gap-3">
        <Logo className="!h-12" />
        <p className="text-xs font-medium text-content-base-default">
          powered by
        </p>
        <div className="flex h-5 w-[47px] items-center text-content-base-default">
          <SmallLogo />
        </div>
      </div>
      <GraniteButton
        className="ml-auto h-[56px] !font-medium"
        variant="secondary"
        size="large"
        onClick={onLogin}
      >
        Login
      </GraniteButton>
    </header>
  );
};

export default Header;
